/* THREE65 product pages (Oct 2026): size buttons, bottom bar, size picker, size guide and the set card.
   Works through Stretch 2.1's own product form: our size buttons drive Stretch's (hidden) variant picker,
   and our Add to cart button submits Stretch's form, so the cart drawer, pixels and checkout behave as before.
   No size is preselected: the form only submits once a size is picked. */
(function () {
  'use strict';
  var doc = document;
  var root = doc.documentElement;
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  function $(s, el) { return (el || doc).querySelector(s); }
  function $$(s, el) { return Array.prototype.slice.call((el || doc).querySelectorAll(s)); }

  var box = $('[data-t65-sizes]');
  if (!box) return;

  var formId = box.getAttribute('data-form');
  var position = box.getAttribute('data-position');
  var LOW = parseInt(box.getAttribute('data-low'), 10);
  if (isNaN(LOW)) LOW = 10;
  var mainGroup = $('[data-t65-group="main"]', box);
  var msgEl = $('[data-t65-msg]', box);
  var atc = $('[data-t65-atc]');
  var readyLabel = atc ? atc.getAttribute('data-ready-label') : 'Add to cart';

  /* ---------- helpers ---------- */
  function readList(group, low) {
    var list = {};
    $$('.t65-size', group).forEach(function (b) {
      var name = b.getAttribute('data-size');
      list[name] = {
        name: name,
        valueId: b.getAttribute('data-value-id'),
        variant: b.getAttribute('data-variant'),
        qty: parseInt(b.getAttribute('data-qty'), 10),
        available: b.getAttribute('data-available') === 'true',
        low: low
      };
    });
    return list;
  }
  function namesOf(group) { return group ? $$('.t65-size', group).map(function (b) { return b.getAttribute('data-size'); }) : []; }
  function isLow(s) { return !!s && s.available && s.qty > 0 && s.qty <= s.low; }
  function stockLine(list, current, names) {
    var s = current && list[current];
    if (isLow(s)) return 'Only ' + s.qty + ' left in ' + s.name;
    var low = names.filter(function (n) { return isLow(list[n]); });
    return low.length ? 'Few left in ' + low.join(', ') : '';
  }
  function setMsg(el, kind, text) {
    if (!el) return;
    el.className = 't65-msg' + (text ? ' t65-' + kind : '');
    el.textContent = text || '';
    el.hidden = !text;
  }
  function flash(el) {
    if (!el) return;
    el.classList.remove('t65-flash');
    void el.offsetWidth;
    el.classList.add('t65-flash');
    setTimeout(function () { el.classList.remove('t65-flash'); }, 1700);
  }
  function focusEl(el) { if (!el) return; try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } }
  function paint(group, list, current) {
    if (!group) return;
    var btns = $$('.t65-size', group);
    btns.forEach(function (btn) {
      var s = list[btn.getAttribute('data-size')];
      if (!s) return;
      var out = !s.available;
      var low = isLow(s);
      btn.classList.toggle('is-out', out);
      btn.setAttribute('aria-checked', String(s.name === current));
      btn.setAttribute('aria-label', s.name + (out ? ', sold out' : low ? ', only ' + s.qty + ' left' : ''));
      var dot = btn.querySelector('.t65-low');
      if (low && !dot) {
        dot = doc.createElement('span');
        dot.className = 't65-low';
        dot.setAttribute('aria-hidden', 'true');
        btn.appendChild(dot);
      } else if (!low && dot) {
        dot.remove();
      }
    });
    var cur = btns.filter(function (b) { return b.getAttribute('aria-checked') === 'true'; })[0] ||
      btns.filter(function (b) { return !b.classList.contains('is-out'); })[0] || btns[0];
    btns.forEach(function (b) { b.tabIndex = b === cur ? 0 : -1; });
  }
  function focusGroup(group) {
    if (!group) return;
    var f = $('.t65-size[aria-checked="true"]', group) || $('.t65-size:not(.is-out)', group);
    if (!f) return;
    $$('.t65-size', group).forEach(function (b) { b.tabIndex = b === f ? 0 : -1; });
    focusEl(f);
  }
  /* size buttons act as one radio group: arrows move and pick, Tab leaves the group */
  function wireGroup(group, pick) {
    if (!group) return;
    group.addEventListener('click', function (e) {
      var b = e.target.closest('.t65-size');
      if (b && group.contains(b)) pick(b.getAttribute('data-size'));
    });
    group.addEventListener('keydown', function (e) {
      var btns = $$('.t65-size', group);
      var i = btns.indexOf(doc.activeElement);
      if (i < 0) return;
      var steps = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
      var j;
      if (steps[e.key]) j = (i + steps[e.key] + btns.length) % btns.length;
      else if (e.key === 'Home') j = 0;
      else if (e.key === 'End') j = btns.length - 1;
      else return;
      e.preventDefault();
      pick(btns[j].getAttribute('data-size'));
      btns.forEach(function (b, k) { b.tabIndex = k === j ? 0 : -1; });
      btns[j].focus();
    });
  }

  /* ---------- state ---------- */
  var SIZES = readList(mainGroup, LOW);
  var ORDER = namesOf(mainGroup);
  var size = null;
  var prompt = '';
  var soldOut = '';
  function form() { return doc.getElementById(formId); }

  /* point Stretch's form and (hidden) variant picker at the size that was picked */
  function syncStretch(s) {
    var f = form();
    var idInput = f && f.querySelector('input[name="id"]');
    if (idInput && s.variant) idInput.value = s.variant;
    var input = doc.querySelector('input[data-option-position="' + position + '"][value="' + s.valueId + '"][form="' + formId + '"]');
    if (input && !input.checked) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function pickSize(name) {
    var s = SIZES[name];
    if (!s) return;
    if (!s.available) {
      size = null;
      prompt = '';
      soldOut = name;
      update();
      return;
    }
    soldOut = '';
    prompt = '';
    size = name;
    syncStretch(s);
    update();
  }

  /* ---------- layers: move to <body> so fixed positioning is never trapped by a parent ---------- */
  var sticky = $('[data-t65-sticky]');
  var pickSheet = $('[data-t65-sheet="pick"]');
  var pickScrim = $('[data-t65-scrim="pick"]');
  var guideSheet = $('[data-t65-sheet="guide"]');
  var guideScrim = $('[data-t65-scrim="guide"]');
  [sticky, pickScrim, pickSheet, guideScrim, guideSheet].forEach(function (el) { if (el) doc.body.appendChild(el); });

  var pickGroup = pickSheet ? $('[data-t65-group="pick"]', pickSheet) : null;
  if (pickGroup) {
    $$('.t65-size', mainGroup).forEach(function (b) { pickGroup.appendChild(b.cloneNode(true)); });
    var fit = $('[data-t65-fit]', box);
    var pickFit = $('[data-t65-pick-fit]', pickSheet);
    if (fit && pickFit) {
      pickFit.textContent = fit.textContent;
      pickFit.hidden = false;
    }
  }
  var pickMsg = pickSheet ? $('[data-t65-pick-msg]', pickSheet) : null;
  var pickAdd = pickSheet ? $('[data-t65-pick-add]', pickSheet) : null;
  var stickyAtc = sticky ? $('[data-t65-sticky-atc]', sticky) : null;
  var stickySize = sticky ? $('[data-t65-sticky-size]', sticky) : null;
  var stickyChangeWrap = sticky ? $('[data-t65-sticky-change-wrap]', sticky) : null;
  var priceText = stickySize ? stickySize.textContent.trim() : '';

  /* ---------- the set card ---------- */
  var setBox = $('[data-t65-set]');
  var pairGroup = setBox ? $('[data-t65-group="pair"]', setBox) : null;
  var PAIR = pairGroup ? readList(pairGroup, parseInt(setBox.getAttribute('data-low'), 10) || LOW) : {};
  var PAIR_ORDER = namesOf(pairGroup);
  var pairSize = null;
  var pairPrompt = '';
  var pairOut = '';
  var mainLabel = setBox ? (setBox.getAttribute('data-main-label') || '') : '';
  var pairLabel = setBox ? (setBox.getAttribute('data-pair-label') || '') : '';

  function updateSet() {
    if (!setBox) return;
    paint(pairGroup, PAIR, pairSize);
    var t;
    if (size && pairSize) t = mainLabel + ' in ' + size + ' + ' + pairLabel.toLowerCase() + ' in ' + pairSize;
    else if (size && pairGroup) t = mainLabel + ' in ' + size + ', ' + pairLabel.toLowerCase() + ' size next';
    else if (pairSize) t = pairLabel + ' in ' + pairSize + ', ' + mainLabel.toLowerCase() + ' size above';
    else t = 'Pick a size for each piece';
    var line = $('[data-t65-set-sizes]', setBox);
    if (line) line.textContent = t;
    var pm = $('[data-t65-pair-msg]', setBox);
    if (pairOut && !pairSize) setMsg(pm, 'stock', pairOut + ' is sold out');
    else if (pairPrompt && !pairSize) setMsg(pm, 'prompt', pairPrompt);
    else setMsg(pm, 'stock', stockLine(PAIR, pairSize, PAIR_ORDER));
  }

  /* ---------- paint everything from state ---------- */
  function update() {
    paint(mainGroup, SIZES, size);
    paint(pickGroup, SIZES, size);
    var promptEl = $('[data-t65-prompt]', box);
    var chosenEl = $('[data-t65-chosen]', box);
    var labelEl = $('[data-t65-label]', box);
    if (promptEl) promptEl.hidden = !!size;
    if (chosenEl) chosenEl.hidden = !size;
    if (labelEl) labelEl.textContent = size || '';
    if (soldOut && !size) {
      setMsg(msgEl, 'stock', soldOut + ' is sold out.');
      setMsg(pickMsg, 'stock', soldOut + ' is sold out.');
    } else if (prompt && !size) {
      setMsg(msgEl, 'prompt', prompt);
      setMsg(pickMsg, 'prompt', prompt);
    } else {
      var line = stockLine(SIZES, size, ORDER);
      setMsg(msgEl, 'stock', line);
      setMsg(pickMsg, 'stock', line);
    }
    if (atc && !atc.disabled) atc.textContent = size ? readyLabel : 'Select a size';
    if (pickAdd) pickAdd.textContent = size ? readyLabel : 'Select a size';
    if (stickySize) stickySize.textContent = size ? 'Size ' + size + ' · ' + priceText : priceText;
    if (stickyChangeWrap) stickyChangeWrap.hidden = !size;
    if (stickyAtc) stickyAtc.textContent = size ? 'Add to cart' : 'Select size';
    updateSet();
  }

  function askSize(text) {
    if (text) {
      prompt = text;
      soldOut = '';
      update();
    }
    mainGroup.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    flash(mainGroup);
    focusGroup(mainGroup);
  }

  /* no size yet: stop Stretch's form before it adds anything.
     With a size: make sure the form carries exactly the size on screen, even if a slow variant fetch landed late. */
  doc.addEventListener('submit', function (e) {
    /* note: form.id would return the hidden input named "id", so read the attribute */
    if (!e.target || !e.target.getAttribute || e.target.getAttribute('id') !== formId) return;
    if (size) {
      var idInput = e.target.querySelector('input[name="id"]');
      if (idInput && SIZES[size] && SIZES[size].variant) idInput.value = SIZES[size].variant;
      return;
    }
    e.preventDefault();
    e.stopImmediatePropagation();
    askSize('Choose your size first.');
  }, true);

  /* if Stretch's picker settles on another variant (two quick taps, responses out of order), point it back */
  doc.addEventListener('variant:change', function (e) {
    if (!size || !e.detail || !e.detail.variant) return;
    var want = SIZES[size];
    if (want && String(e.detail.variant.id) !== String(want.variant)) syncStretch(want);
  });

  doc.addEventListener('cart:error', function (e) {
    if (!e.target || !e.target.getAttribute || e.target.getAttribute('id') !== formId) return;
    var d = e.detail || {};
    var text = d.error || d.message || d.description;
    setMsg(msgEl, 'prompt', typeof text === 'string' && text ? text : 'Could not add to cart. Please try again.');
  });

  function submitForm() {
    var f = form();
    if (!f || !atc) return;
    if (f.requestSubmit) f.requestSubmit(atc);
    else atc.click();
  }

  /* ---------- layers ---------- */
  var openLayer = null;
  var returnFocus = null;
  function showLayer(sheet, scrim) {
    sheet.hidden = false;
    scrim.hidden = false;
    void sheet.offsetWidth;
    sheet.classList.add('is-open');
    scrim.classList.add('is-open');
    root.classList.add('t65-lock');
  }
  function hideLayer(sheet, scrim) {
    sheet.classList.remove('is-open');
    scrim.classList.remove('is-open');
    root.classList.remove('t65-lock');
    var done = function () {
      if (!sheet.classList.contains('is-open')) {
        sheet.hidden = true;
        scrim.hidden = true;
      }
    };
    if (reduce) done(); else setTimeout(done, 260);
  }
  function openGuide(ret) {
    if (!guideSheet) return;
    returnFocus = ret || doc.activeElement;
    showLayer(guideSheet, guideScrim);
    openLayer = 'guide';
    focusEl($('[data-t65-close]', guideSheet));
  }
  function closeGuide() {
    if (!guideSheet) return;
    hideLayer(guideSheet, guideScrim);
    openLayer = null;
    if (returnFocus && doc.contains(returnFocus)) focusEl(returnFocus);
  }
  function openPick(ret) {
    if (!pickSheet) return;
    returnFocus = ret || stickyAtc;
    soldOut = '';
    prompt = '';
    update();
    showLayer(pickSheet, pickScrim);
    openLayer = 'pick';
    focusGroup(pickGroup);
  }
  function closePick(keepFocus) {
    if (!pickSheet) return;
    hideLayer(pickSheet, pickScrim);
    openLayer = null;
    if (!keepFocus && returnFocus && doc.contains(returnFocus)) focusEl(returnFocus);
  }
  function focusables(el) {
    return $$('button, [href], select, input, textarea, [tabindex]:not([tabindex="-1"])', el).filter(function (n) {
      return !n.disabled && n.offsetParent !== null;
    });
  }
  doc.addEventListener('keydown', function (e) {
    if (!openLayer) return;
    var sheet = openLayer === 'guide' ? guideSheet : pickSheet;
    if (e.key === 'Escape') {
      e.preventDefault();
      if (openLayer === 'guide') closeGuide(); else closePick();
      return;
    }
    if (e.key !== 'Tab') return;
    var f = focusables(sheet);
    if (!f.length) return;
    var first = f[0];
    var last = f[f.length - 1];
    var inside = sheet.contains(doc.activeElement);
    if (e.shiftKey && (doc.activeElement === first || !inside)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (doc.activeElement === last || !inside)) { e.preventDefault(); first.focus(); }
  });

  $$('[data-t65-open-guide]').forEach(function (b) { b.addEventListener('click', function () { openGuide(b); }); });
  if (guideSheet) {
    $('[data-t65-close]', guideSheet).addEventListener('click', closeGuide);
    guideScrim.addEventListener('click', closeGuide);
    /* inches by default; the sheet's numbers are cm */
    var cells = $$('td[data-cm]', guideSheet);
    var unitBtns = $$('.t65-unit button', guideSheet);
    unitBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var u = btn.getAttribute('data-unit');
        unitBtns.forEach(function (x) { x.setAttribute('aria-pressed', String(x === btn)); });
        cells.forEach(function (td) { td.textContent = td.getAttribute('data-' + u); });
      });
    });
  }
  if (pickSheet) {
    $('[data-t65-close]', pickSheet).addEventListener('click', function () { closePick(); });
    pickScrim.addEventListener('click', function () { closePick(); });
    var pickGuide = $('[data-t65-pick-guide]', pickSheet);
    if (pickGuide) {
      pickGuide.addEventListener('click', function () {
        var ret = returnFocus;
        closePick(true);
        openGuide(ret);
      });
    }
    pickAdd.addEventListener('click', function () {
      if (!size) {
        prompt = 'Choose your size first.';
        update();
        flash(pickGroup);
        focusGroup(pickGroup);
        return;
      }
      closePick(true);
      submitForm();
    });
  }
  if (stickyAtc) {
    stickyAtc.addEventListener('click', function () {
      if (!size) { openPick(stickyAtc); return; }
      submitForm();
    });
    var change = $('[data-t65-sticky-change]', sticky);
    if (change) change.addEventListener('click', function () { openPick(stickyAtc); });
  }

  /* bottom bar: only while the main button is off screen, and out of the tab order while hidden */
  if (sticky && atc && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      /* phones: whenever the main button is off screen; tablets: only once it has been scrolled past */
      var show = !entries[0].isIntersecting && (window.innerWidth < 700 || entries[0].boundingClientRect.top < 0);
      sticky.classList.toggle('is-shown', show);
      sticky.setAttribute('aria-hidden', String(!show));
      sticky.inert = !show;
    }, { rootMargin: '0px 0px -72px 0px' }).observe(atc);
  }

  /* set card: adds both pieces in one go, then opens the cart like a normal add */
  if (setBox) {
    wireGroup(pairGroup, function (name) {
      var s = PAIR[name];
      if (!s) return;
      if (!s.available) { pairSize = null; pairOut = name; pairPrompt = ''; }
      else { pairOut = ''; pairPrompt = ''; pairSize = name; }
      updateSet();
    });
    var addSet = $('[data-t65-add-set]', setBox);
    var setErr = $('[data-t65-set-err]', setBox);
    addSet.addEventListener('click', async function () {
      setMsg(setErr, 'prompt', '');
      if (!size) { askSize('Choose your ' + mainLabel.toLowerCase() + ' size first.'); return; }
      var pairVariant;
      if (pairGroup) {
        if (!pairSize) {
          pairPrompt = 'Choose a ' + pairLabel.toLowerCase() + ' size.';
          pairOut = '';
          updateSet();
          flash(pairGroup);
          focusGroup(pairGroup);
          return;
        }
        pairVariant = PAIR[pairSize].variant;
      } else {
        pairVariant = setBox.getAttribute('data-single');
      }
      addSet.disabled = true;
      addSet.setAttribute('aria-busy', 'true');
      try {
        if (!window.THREE65 || !window.THREE65.addToCart) throw new Error('Could not add the set. Please try again.');
        await window.THREE65.addToCart([
          { id: Number(SIZES[size].variant), quantity: 1 },
          { id: Number(pairVariant), quantity: 1 }
        ], 'variant:add');
      } catch (err) {
        setMsg(setErr, 'prompt', err.message);
      } finally {
        addSet.disabled = false;
        addSet.removeAttribute('aria-busy');
      }
    });
  }

  /* delivery dates in the dispatch promise */
  var eta = $('[data-t65-eta]');
  if (eta) {
    var addBiz = function (d, n) {
      var r = new Date(d.getTime());
      var k = 0;
      while (k < n) { r.setDate(r.getDate() + 1); var w = r.getDay(); if (w !== 0 && w !== 6) k++; }
      return r;
    };
    var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var now = new Date();
    var first = addBiz(addBiz(now, 1), 3);
    var last = addBiz(addBiz(now, 2), 5);
    var range = MON[first.getMonth()] + ' ' + first.getDate() + ' to ' + (first.getMonth() === last.getMonth() ? '' : MON[last.getMonth()] + ' ') + last.getDate();
    eta.textContent = 'Arrives ' + range + ' in Ontario.';
  }

  /* "See the details" scrolls smoothly */
  $$('[data-t65-to-details]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var target = doc.getElementById('t65-details');
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });
  });

  /* desktop: some accordions start open */
  try {
    if (window.matchMedia('(min-width: 1000px)').matches) $$('[data-t65-open-desktop]').forEach(function (d) { d.open = true; });
  } catch (e) {}

  wireGroup(mainGroup, pickSize);
  wireGroup(pickGroup, pickSize);
  update();
})();
